import React, { useEffect, useRef,useState } from "react";
import $ from "jquery";
import axios from "axios";
import "datatables.net-bs";
import "datatables.net-buttons-bs";
import "datatables.net-buttons/js/buttons.colVis.js";
import "datatables.net-buttons/js/buttons.html5.js";
import "datatables.net-buttons/js/buttons.print.js";
import "datatables.net-colreorder-bs";
import "datatables.net-select-bs";
import DatePicker from "react-datepicker"; 
import {strEncode,strDecode} from '../../../encrpt';
import {API_BASE_URL} from "../../../apiConfig.jsx";

const Datatable = ({ apiUrl, queryParams, onInputChange,formData}) => {
  const tableRef = useRef(null);
  const headersRef = useRef([]);
  const [data, setData] = React.useState([]);
 // const [formData, setFormData] = useState(data.map(row => ({ ...row, dateValue: row.date || null })));
  useEffect(() => {
    fetchData();
  }, [queryParams]);

  const inputRefs = useRef({}); 

  useEffect(() => {
    if (tableRef.current && data.length > 0) {
      initializeDataTable();
    }
  }, [data]);

  const fetchData = async () => {
    try {
      const response = await axios.get(apiUrl, { params: queryParams }); // ✅ Pass queryParams dynamically
      headersRef.current = response.data.headers;
      setData(response.data.rows);
      setData(formData);
    } catch (error) {
      console.error("Error fetching data", error);
    }
  };

  const initializeDataTable = () => {
    if ($.fn.DataTable.isDataTable(tableRef.current)) {
      $(tableRef.current).DataTable().destroy(); // ✅ Destroy existing table instance
    }
  
    $(tableRef.current).DataTable({
      paging: true,
      searching: true,
      ordering: true,
      responsive: true,
      buttons: ["copy", "excel", "pdf"],
    });
  };

  return (
    <table ref={tableRef} className="table table-striped table-bordered table-hover">
      <thead>
        {headersRef.current.map((headerRow, rowIndex) => (
          <tr key={rowIndex}>
            {headerRow.map((col, colIndex) => (
              <th key={colIndex} colSpan={col.colSpan || 1} rowSpan={col.rowSpan || 1}>
                {col.title}
              </th>
            ))}
          </tr>
        ))}
      </thead>
      <tbody>
  {data.map((row, rowIndex) => (
    <tr key={rowIndex}>
      {Object.entries(row).map(([colName, colValue], colIndex) => {
        const maxLength = headersRef.current.length;
         const displayName = headersRef.current[maxLength - 1][colIndex].title;
              if (displayName.includes("Date")) {
                return (
                  <td key={colIndex}>
                    <DatePicker
                      selected={colValue && !isNaN(Date.parse(colValue)) ? new Date(colValue) : new Date()}
                      onChange={(date, event) => onInputChange(rowIndex, colName, date, event, row,displayName)}
                      dateFormat="yyyy-MM-dd"
                      className="input-box"
                      placeholderText="Select Date"
                    />
                  </td>
                );
              } else if (displayName.includes("Réalisation") || displayName.includes("Revue")) {
                return (
                  <td key={colIndex}>
                    <input
                      type="text"
                      ref={(el) => (inputRefs.current[`${rowIndex}-${colName}`] = el)}
                      value={colValue ?? ""}
                      onChange={(e) => onInputChange(rowIndex, colName, e.target.value, e, row,displayName)}
                      className="input-box"
                    />
                   
                  </td>
                );
              }
              else if(displayName.includes("Commentaires")) {
                return (
                  <td key={colIndex}>
                    <textarea
                      type="text"
                      value={colValue || ""}
                      onChange={(e) => onInputChange(rowIndex, colName, e.target.value, e, row,displayName)}
                      className="input-box"
                    />
                  </td>
                );
              }
              else {
                return <td key={colIndex}>{colValue}</td>;
              }
            })}
    </tr>
  ))}
</tbody>
    </table>
  );
};

export default Datatable;